import { render, staticRenderFns } from "./spindex.vue?vue&type=template&id=f5180c34&"
import script from "./spindex.vue?vue&type=script&lang=js&"
export * from "./spindex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports